import { getOnboardingSteps } from "@yardzen/rest-api-client";
import useSWR from "swr";

export const useOnboarding = (accountId: string, designProjectId: string) => {
  const { data, error, isLoading, mutate } = useSWR(
    accountId && designProjectId
      ? `/accounts/${accountId}/design-projects/${designProjectId}/onboarding`
      : null,
    accountId && designProjectId
      ? () => getOnboardingSteps(accountId, designProjectId)
      : null,
  );

  return {
    onboarding: data?.data,
    isLoading,
    isError: error,
    // Revalidate the shared onboarding cache. The App Router onboarding layout
    // persists across step navigations, so the SWR subscription never remounts
    // between steps and won't auto-refetch on a client-side nav — call this
    // when a step needs the latest data written by a previous step.
    mutate,
  };
};
